import React from 'react';

const ServiceSuspended = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] px-6 selection:bg-[#30D5C8]/30">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Visual Indicator - Optional subtle top border */}
        <div className="w-12 h-[2px] bg-[#30D5C8] mx-auto mb-8 opacity-50" />

        <header className="space-y-2">
          <h1 className="text-[#30D5C8] text-2xl md:text-3xl font-medium tracking-tight">
            Service Interruption
          </h1>
          <div className="h-px w-full bg-white/5" />
        </header>

        <main>
          <p className="text-gray-400 text-sm md:text-base leading-relaxed font-light">
            The website for this domain is temporarily unavailable. 
            If you are the site administrator, please refer to your latest 
            technical correspondence to restore service.
          </p>
        </main>

        <footer className="pt-4">
          <a 
            href="mailto:service@zicreates.com"
            className="text-xs uppercase tracking-widest text-gray-500 hover:text-[#30D5C8] transition-colors duration-300"
          >
            Contact Administration
          </a>
        </footer>
      </div>
    </div>
  );
};

export default ServiceSuspended;